import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_PORTAL_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_PORTAL_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anonKey) {
  throw new Error(
    "Partner Portal: missing VITE_PORTAL_SUPABASE_URL / VITE_PORTAL_SUPABASE_ANON_KEY (.env)",
  );
}

export const SUPABASE_URL = url;
export const SUPABASE_ANON_KEY = anonKey;
export const EDGE_FUNCTION_BASE = `${url}/functions/v1/make-server-9924f985`;

export const supabase: SupabaseClient = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: "warmteo-partner-portal-auth",
  },
});
